import React, { useCallback } from 'react'
import LoginForm from './components/LoginForm/LoginForm'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { CreateAccountForm } from './components/CreateAccountForm'
import LoginLayout from './components/LoginLayout'
import useFirebaseAuthentication from '../../utils/Firebase/hooks/useFirebaseAuthentication'
import PasswordRecoveryForm from './components/PasswordRecoveryForm/PasswordRecoveryForm'
import { useAppDispatch } from '../../store/utils/hooks'
import { actionResetUserState } from '../../store/slices/user/userSlice'
import { useMemo } from 'react'
import { CRM_STATUS_PATH } from '../../routes/CrmRoutes'
import { ONBOARDING_PATH } from '../../routes/OnboardingRoutes'
import { LOGIN_PATH, RECOVERY_PATH, REGISTER_PATH } from '../../routes/LoginRoutes'
import { HOME_PATH } from '../../routes/HomeRoutes'

export default function LoginPage() {
	const dispatch = useAppDispatch()
	const { loading, authUser } = useFirebaseAuthentication()
	const location = useLocation()
	const navigate = useNavigate()
	const params = useMemo(() => new URLSearchParams(location.search), [location.search])

	const createAccount = useCallback(() => {
		dispatch(actionResetUserState())
		navigate(ONBOARDING_PATH)
	}, [dispatch, navigate])

	if (loading) {
		return null
	}

	if (location.pathname === '/recovery') {
		return (
			<LoginLayout>
				<PasswordRecoveryForm navigate={() => navigate(LOGIN_PATH)} />
			</LoginLayout>
		)
	}

	if (authUser) {
		if (params.get('code') && params.get('marketplace')) {
			return (
				<Navigate
					to={`${CRM_STATUS_PATH}/?code=${params.get('code')}&marketplace=${params.get('marketplace')}`}
				/>
			)
		} else {
			return <Navigate to={HOME_PATH} />
		}
	} else {
		return (
			<LoginLayout>
				{location.pathname.includes(LOGIN_PATH) && (
					<LoginForm switchToCreate={createAccount} navigate={() => navigate(RECOVERY_PATH)} />
				)}
				{location.pathname === REGISTER_PATH && <CreateAccountForm />}
			</LoginLayout>
		)
	}
}
